// extracted by mini-css-extract-plugin
module.exports = {"customCheckbox":"customCheckbox_customCheckbox__Pwh1H","checkmark":"customCheckbox_checkmark__xrg4j"};